import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import pages from "./pages";
import useAuth from "../../auth/useAuth";
import LoginPage from "./login";
import Abort404 from "../modules/abort404";
import Permission from "../../inc/Permission";

// Рендер роутов по правам (через Permission.Check — при выключенном гейте пускает всех, см.
// inc/Permission.js): страница не попала в дерево → её URL ловит "*" и отдаёт Abort404, т.е.
// раздел выглядит как несуществующий. Защита — редирект /login.
export default function PagesRouter() {
    const { isAuthReady, isAuthenticated } = useAuth();
    // Подписка на права нужна для пересчёта дерева роутов при их смене (логин/логаут).
    // eslint-disable-next-line no-unused-vars
    const userPermissions = useSelector((state) => state.app.userPermissions);

    // Пока сессия не поднята из StorageLocal — защищённый UI не рендерим
    if (!isAuthReady) {
        return <div className="app__loader"><LinearProgress/></div>;
    }

    return <Routes>
        <Route path="/login" element={<LoginPage/>}/>
        {pages.all
            .filter((page) => page.permission === null || Permission.Check(page.permission.name))
            .map((page) =>
                <Route
                    key={page.route.name}
                    path={page.route.mask}
                    element={isAuthenticated
                        ? <page.Component
                            route={page.route}
                            routes={page.routes}
                            path={page.path}
                            type={page.slug}
                            withContent={true}
                        />
                        : <Navigate to="/login" replace={true}/>}
                />
            )}
        <Route
            path="/"
            element={<Navigate to={isAuthenticated ? '/nodes' : '/login'} replace={true}/>}
        />
        <Route path="*" element={<Abort404/>}/>
    </Routes>;
}
